var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-input", {
    staticClass: "search",
    attrs: {
      placeholder: _vm.placeholder,
      "prefix-icon": "el-icon-search",
      size: "small",
      maxlength: _vm.maxlength,
    },
    nativeOn: {
      keyup: function ($event) {
        if (
          !$event.type.indexOf("key") &&
          _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
        ) {
          return null
        }
        return _vm.submit($event)
      },
    },
    model: {
      value: _vm.val,
      callback: function ($$v) {
        _vm.val = $$v
      },
      expression: "val",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }